'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = featured;
exports.isLoaded = isLoaded;
exports.index = index;

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'featured/LOAD';
var LOAD_SUCCESS = 'featured/LOAD_SUCCESS';
var LOAD_FAIL = 'featured/LOAD_FAIL';

var initialState = {
  data: [],
  loaded: false,
  loading: false,
  pagination: {
    current_page: null,
    total_pages: null
  },
  promise: null
};

function featured() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      if (state.promise && state.promise.cancel) {
        state.promise.cancel();
      }
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: true,
        promise: action.promise
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error,
        loaded: false,
        promise: null
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        data: action.result.data ? action.result.data : action.result,
        loaded: true,
        loading: false,
        pagination: action.result.meta.pagination ? action.result.meta.pagination : null,
        promise: null
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.events && globalState.events.loaded;
}

function index() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('calendars/' + process.env.CALENDAR_ID + ('/featured?order=start_date&per=' + _config.app.featured.limit));
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/featured.js
// module id = 641
// module chunks = 0